import { Component, OnInit, ViewEncapsulation } from '@angular/core'

@Component({
  standalone: false,

  selector: 'vs-guest-landing-page',
  templateUrl: './guest-landing-page.component.html',
  styleUrls: ['./guest-landing-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GuestLandingPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
